
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Typography } from "@mui/material";
import LandingCurrentDateTime from "../components/LandingCurrentDateTime";


const LandingScreen = () => {
  const [bgImageLoaded, setBgImageLoaded] = useState(true);

    useEffect(() => {
    const img = new Image();
    img.src = "/assets/images/bookonline-bg1.jpg";
    img.onload = () => setBgImageLoaded(true);
    img.onerror = () => setBgImageLoaded(false);
  }, []);


  const navigate = useNavigate();
  const APP_VERSION = "V.0.1";

  const handleProceed = () => {

      navigate("/online-appointment/ticket-schedule");

  };

  return (
    <section
      className="d-table w-100"
      id="home"
   style={{
        backgroundImage: bgImageLoaded ? `url(/assets/images/bookonline-bg1.jpg)` : "none",
        backgroundColor: bgImageLoaded ? "transparent" : "gray",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        backgroundAttachment: 'fixed',
        paddingTop: '40px',
      }}
    >
       <LandingCurrentDateTime /> 
      <div className="bg-overlay-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-5">
              
            </div>

            <div className="col-xl-7">
              <div className="heading-title text-center">
                <div className="mt-4 pt-2">
                  <div className="rounded text-start p-4" 
                  style={{backgroundColor:'rgba(255, 255, 255, 0.8)',
                  border:'1px solid #424242',
                  boxShadow:'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(184, 184, 184, 0.5) 2px 2px 32px 2px'
                  }}>
                    <div className="row align-items-center">
                    <h4 className="fw-bold text-black title-dark">Online Appointment</h4>
                <h6 style={{color:'#396cf0'}} className="mt-3">Step1</h6>
                <p style={{color:'#000',fontSize:'14px' }}>Input your name, phone number and email address.</p>
                <h6 style={{color:'#396cf0'}}>Step2</h6>
                <p style={{color:'#000',fontSize:'14px' }}>Select the branch, then select the service, preferred date, and preffered time.</p>
                <h6 style={{color:'#396cf0'}}>Step3</h6>
                <p style={{color:'#000',fontSize:'14px' }}>Your Queue Ticket will be created and sent to your email address with a confirmation number.</p>
                <h4 className="fw-bold text-black title-dark">Branch Check In</h4> 
                <p style={{color:'#000',fontSize:'14px' }}>Select 'Online Appointment' and input the confirmation Code. You will then be called at the scheduled time.</p>
                <button type="button" className="btn btn-primary" onClick={handleProceed}>Get Started</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
     <Box
       sx={{
         position: "absolute",
         bottom: 10,
         left: 10,
       }}
     >
       <Typography
          variant="caption"
          sx={{ color: "rgba(255, 255, 255, 0.7)", fontWeight: "300" }}
       >
          {APP_VERSION}
       </Typography>
     </Box>
   </section>
  );
};

export default LandingScreen;
